/* eslint-disable no-template-curly-in-string */
import { object, string, number } from 'yup';

export const discountValidationSchema = object().shape({
    name: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
        .required('Required'),
    rate: number()
        .moreThan(0, 'Should be greater than ${more}')
        .max(100, 'Should be less than ${max}')
        .required('Required'),
    description: string()
        .min(2, ('Too Short!'))
        .max(50, 'Too Long!')
});